<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
                   [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">SITUAÇÃO DO VEÍCULO</span>
        <span>{{consulta?.situacaoVeiculo || 'NÃO INFORMADO'}}</span>
      </li>
      <li>
        <span class="text-secondary">SITUAÇÃO DO CHASSI</span>
        <span>{{consulta?.tipoRemarcacaoChassi || consulta?.remarcacaoChassi|| 'NÃO INFORMADO'}}</span>
      </li>
      <li>
        <span class="text-secondary">VEÍCULO ROUBADO</span>
        <span *ngIf="possuiRouboFurtoFederal" class="text-danger fw-500">SIM</span>
        <span *ngIf="!possuiRouboFurtoFederal" class="">NÃO</span>
      </li>
    </ul>

    <h2 class="subtitle">DADOS CADASTRAIS</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">PLACA </span><span>{{consulta?.placa || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CHASSI </span><span>{{consulta?.chassi || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DE MOTOR
        </span><span>{{consulta?.nrMotor || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DA CAIXA DE CÂMBIO
        </span><span>{{consulta?.nrCaixaCambio || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">POTÊNCIA </span><span>{{consulta?.potencia || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CILINDRADAS </span><span>{{consulta?.cilindrada || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">RENAVAM </span><span>{{consulta?.renavam || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">DATA DA ÚLTIMA ATUALIZAÇÃO
        </span><span>{{consulta?.dataUltimaAtualizacao || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">MUNICÍPIO/UF </span><span>{{consulta?.municipio || 'NÃO INFORMADO'}} /
          {{consulta?.uf || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CPF/CNPJ FATURADO
        </span><span>{{consulta?.cpfCnpjFaturado || 'NÃO INFORMADO'}}</span></li>
    </ul>

    <h2 class="subtitle">DESCRIÇÃO DO VEÍCULO</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">MARCA/MODELO </span> <span>{{consulta?.marca || consulta?.marcaModelo || 'NÃO INFORMADO'}} </span></li>
      <li><span class="text-secondary">ANO DE FABRICAÇÃO </span> <span>{{consulta?.anoFabricacao || 'NÃO INFORMADO'}}
        </span></li>
      <li><span class="text-secondary">ANO DO MODELO </span> <span>{{consulta?.anoModelo || 'NÃO INFORMADO'}} </span>
      </li>
      <li><span class="text-secondary">COMBUSTÍVEL </span> <span>{{consulta?.combustivel || 'NÃO INFORMADO'}} </span>
      </li>
      <li><span class="text-secondary">COR </span> <span>{{consulta?.cor || 'NÃO INFORMADO'}} </span></li>
      <li><span class="text-secondary">Espécie </span> <span>{{consulta?.especie || 'NÃO INFORMADO'}} </span></li>
      <li><span class="text-secondary">NÚMERO DE PASSAGEIROS </span>
        <span>{{consulta?.capacidadePassageiros || 'NÃO INFORMADO'}} </span></li>
    </ul>

    <div *ngIf="consulta?.procedenciaVeiculo!='NACIONAL'">
      <h2 class="subtitle">DADOS DE IMPORTAÇÃO</h2>
      <ul class="card-list-striped">
        <li><span class="text-secondary">Procedência
          </span><span>{{consulta?.procedenciaVeiculo || 'NÃO INFORMADO'}}</span>
        </li>
        <li><span class="text-secondary">Situação veículo
          </span><span>{{consulta?.situacaoVeiculo|| 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Importação </span><span>{{consulta?.importacao || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Data DI </span><span>{{consulta?.dataDI || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Número DI </span><span>{{consulta?.numeroDI || 'NÃO INFORMADO'}}</span></li>
      </ul>
    </div>

    <h2 class="subtitle">FICHA TÉCNICA</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">TIPO DE MONTAGEM
        </span><span>{{consulta?.montagem || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">TIPO DE VEÍCULO </span><span>{{consulta?.tipo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">PESO BRUTO TOTAL </span><span>{{consulta?.ptb || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CAPACIDADE MÁXIMA DE TRAÇÃO
        </span><span>{{consulta?.cmt || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CAPACIDADE DE CARGA
        </span><span>{{consulta?.capacidadeCarga || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Nº DA CARROCERIA
        </span><span>{{consulta?.nrCarroceria || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">CARROCERIA </span><span>{{consulta?.FALTA || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">QUANTIDADE DE EIXOS </span><span>{{consulta?.nrEixos || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">TERCEIRO EIXO </span><span>{{consulta?.numEixosAux || 'NÃO INFORMADO'}}</span>
      </li>
    </ul>

    <h2 class="subtitle" *ngIf="false">COMUNICAÇÃO DE VENDA</h2>
    <ul class="card-list-striped" *ngIf="false">
      <li class="w-100 mw-100"><span class="text-secondary">INDICADOR COMUNICAÇÃO VENDA</span>
        <span>{{consulta?.indicadorComunicaVenda || 'NÃO INFORMADO'}} </span></li>
    </ul>

    <h2 class="subtitle">RESTRIÇÕES</h2>
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">ADMINISTRATIVA</span>
        <span [ngClass]="{'text-danger fw-500': restricaoAdministrativa }">
          <span>{{restricaoAdministrativa || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">ALIENAÇÃO</span>
        <span [ngClass]="{'text-danger fw-500': alienacao }">
          <span>{{alienacao || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">ARRENDAMENTO</span>
        <span [ngClass]="{'text-warning fw-500': arrendamento }">
          <span>{{arrendamento || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">JUDICIAL</span>
        <span [ngClass]="{'text-danger fw-500': restricaoJudicial }">
          <span>{{restricaoJudicial || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">RESERVA DE DOMÍNIO</span>
        <span [ngClass]="{'text-warning fw-500': reservaDominio }">
          <span>{{reservaDominio || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">ROUBO E FURTO ATIVO</span>
        <span [ngClass]="{'text-danger fw-500': rouboFurto }">
          <span>{{rouboFurto || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">SINISTRO RECUPERADO</span>
        <span [ngClass]="{'text-danger fw-500': sinistroRecuperado }">
          <span>{{sinistroRecuperado || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">TRIBUTÁRIO</span>
        <span [ngClass]="{'text-warning fw-500': restricaoTributaria }">
          <span>{{restricaoTributaria || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">OBSERVAÇÕES</span>
        <ng-container>
          <span *ngIf="!observacoes || observacoes.trim().length === 0">
            NADA CONSTA
          </span>
          <span *ngIf="observacoes && observacoes.trim().length > 0">
            <span 
              *ngFor="let ob of observacoes.split(';')" 
              [ngClass]="{
                'text-danger': 
                  !ob.trim().toUpperCase().includes('NÃO') &&
                  !ob.trim().toUpperCase().includes('NAO')
              }">
              {{ ob.trim() }}{{ (!last && ob.trim() !== '') ? ';' : '' }}&nbsp;
            </span>
          </span>
        </ng-container>
      </li>    
    </ul>

    <div ng-show="consulta?.showGravame" *ngIf="false">
      <h2 class="subtitle">GRAVAME</h2>
      <ul class="card-list card-list-striped">
        <li><span class="text-secondary">AGENTE FINANCEIRO</span>
          <span>{{consulta?.nomeAgenteFinanceiro || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">NOME
            FINANCIADO</span><span>{{consulta?.nomeFinanciado || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">DATA DE INCLUSÃO</span>
          <span>{{consulta?.dataInclusaoFinanc || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">RESTRIÇÃO FINANCEIRA</span>
          <span>{{consulta?.tipoRestricaoFinanceira || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">CPF/CNPJ FINANCIADO</span>
          <span>{{consulta?.cpfCnpjFinanciado || 'NÃO INFORMADO'}}</span></li>
      </ul>
    </div>

    <ng-container *ngIf="consulta?.lista!=null && consulta?.lista.length>0">
      <ng-container *ngFor="let v of consulta?.lista; let i = index;">
        <h2 class="subtitle subtitle-danger ">{{i+1}}º OCORRÊNCIA</h2>
        <ul class="card-list-striped">
          <li><span class="text-secondary">Categoria ocorrência </span>
            <span>{{v?.categoriaOcorrencia|| "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Órgão de segurança </span>
            <span>{{v?.orgaoSeguranca || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Número ocorrência </span>
            <span>{{v?.numeroOcorrencia || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Data ocorrência </span> <span>{{v?.dataOcorrencia || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Município emplacamento </span>
            <span>{{consulta?.municipio || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Marca/Modelo </span>
            <span>{{consulta?.marcaModelo || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Ano modelo </span> <span>{{consulta?.anoModelo|| "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Ano </span> <span>{{v?.ano || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Boletim </span> <span>{{v?.boletim || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Tipo declaração </span> <span>{{v?.tipoDeclaracao || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Alarme </span> <span>{{v?.alarme || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">UF emplacamento </span> <span>{{consulta?.uf || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Cor </span> <span>{{consulta?.cor || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Ano fabricação </span><span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span></li>
        </ul>
      </ng-container>
    </ng-container>

  </ng-container>

</app-card-consulta>
